import http from '@/utils/axios';
import { deleteToken, storeToken, getToken, getDetails } from '@/utils/auth';

/**
 * This store handles the login process
 */
export default {
    namespaced: true,
    state: {
        status: '',
        token: getToken || null,
        user: '',
    },
    mutations: {
        AUTH_REQUEST(state) {
            state.status = 'loading';
        },
        AUTH_SUCCESS(state, userData) {
            http.defaults.headers.common.Authorization = `Bearer ${userData.token}`;
            storeToken(
                userData.token
            );
            state.status = 'success';
        },
        REMOVE_TOKEN() {
            deleteToken();
        },
        AUTH_ERROR(state) {
            deleteToken();
            state.status = 'error';
        },
    },
    actions: {
        login({ commit }, authData) {
            commit('AUTH_REQUEST');
            return new Promise((resolve, reject) => {
                http.post('/api/v1/login', {
                    user: authData.username,
                    pass: authData.password,
                })
                    .then(response => {
                        commit('AUTH_SUCCESS', {
                            token: response.data.token
                        });
                        resolve(getDetails());
                    })
                    .catch(err => {
                        commit('AUTH_ERROR');
                        reject(err);
                    });
            });
        },
        logoutUser({ commit }) {
            commit('REMOVE_TOKEN');
        },
    },
    getters: {
        getJwtToken: () => getToken(),
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
    },
};
